var _path, _g, _path2, _ellipse, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathLesson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 97,
    viewBox: "0 0 100 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 92C74.3443 92 95 74.1262 95 51C95 27.8738 74.3443 10 50 10C25.6557 10 5 27.8738 5 51C5 74.1262 25.6557 92 50 92Z",
    stroke: "#A56644",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_4103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 42,
    rx: 40,
    ry: 36,
    fill: "#E57E04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 81C73.4431 81 93 63.8286 93 42C93 20.1714 73.4431 3 50 3C26.5569 3 7 20.1714 7 42C7 63.8286 26.5569 81 50 81Z",
    stroke: "#E57E04",
    strokeWidth: 6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81C73.4431 81 93 63.8286 93 42C93 20.1714 73.4431 3 50 3C26.5569 3 7 20.1714 7 42C7 63.8286 26.5569 81 50 81Z",
    fill: "#E7A601",
    stroke: "#FFC800",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_4103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 80,
    height: 72
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 42,
    rx: 40,
    ry: 36,
    fill: "#E7A601"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_4103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 42,
    rx: 40,
    ry: 36,
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 16.5,
    y: 35.9771,
    width: 94.72,
    height: 18.0332,
    rx: 9.01662,
    transform: "rotate(-45 16.5 35.9771)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 20.3398,
    y: 75.9287,
    width: 95.1039,
    height: 25.3792,
    transform: "rotate(-45 20.3398 75.9287)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5553 59.4344C38.1486 60.6264 35.3784 58.6462 35.787 56.0259L37.3868 45.7665L29.9632 38.3916C28.0672 36.5081 29.1253 33.304 31.7845 32.8766L42.1964 31.2032L47.0314 21.978C48.2663 19.6219 51.6905 19.6219 52.9254 21.978L57.7605 31.2032L68.1723 32.8766C70.8315 33.304 71.8896 36.5081 69.9936 38.3916L62.57 45.7665L64.1698 56.0259C64.5784 58.6462 61.8082 60.6264 59.4015 59.4344L49.9784 54.7671L40.5553 59.4344Z",
    fill: "#E57E04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1009 28.1012C50.1009 26.3564 47.6252 26.0174 47.1561 27.698L45.5365 33.5012L37.9014 34.7177C35.7133 35.0664 35.3637 38.0701 37.4132 38.912L50.1009 44.1238V28.1012Z",
    fill: "#FFC800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_4103",
    x: 4,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.494118 0 0 0 0 0.0156863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_4103"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_4103",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathLesson);
export default __webpack_public_path__ + "static/media/path-lesson.0e1c0b222f607e35d093d1df743e7fd8.svg";
export { ForwardRef as ReactComponent };